<template>
  <HModal
    :visible="visible"
    :show-close="false"
  >
    <span
      class="close-box sprite-lifelong-vip-discount sprite-lifelong-vip-discount-close"
      @click="close"
    />
    <div class="wrapper-box">
      <header>
        <h2>终身VIP限时特惠</h2>
        <p class="activity-time">
          活动剩余时间：
        </p>
        <div class="time-wrapper">
          <VueCountdown
            :time="countdown"
            :auto-start="autoStart"
            :transform="transform"
            class="times"
            @end="endCountdown"
          >
            <template slot-scope="{ hours, minutes, seconds }">
              <template
                v-for="(value, name, index) in { hours, minutes, seconds }"
              >
                <span
                  :key="`key-${index}`"
                  class="time-item"
                >{{
                  value[0] || 0
                }}</span>
                <span
                  :key="index"
                  class="time-item"
                >{{ value[1] || 0 }}</span>
              </template>
            </template>
          </VueCountdown>
        </div>

        <div
          v-if="paySetting && paySetting.id"
          class="money-wrap sprite-lifelong-vip-discount sprite-lifelong-vip-discount-money-bg"
        >
          <p class="money">
            {{ `￥${paySetting.current_price || 0}` }}
          </p>
          <div class="discount">
            <p class="discount-text">
              {{ `现价¥${paySetting.current_price || 0}` }}
              <span>{{ paySetting.bottom }}</span>
            </p>
            <p class="discount-money">
              {{ `再减¥${preferentialPrice}` }}
            </p>
          </div>
        </div>
      </header>

      <main>
        <div class="qrcode">
          <span
            v-if="!loginStatus || isExpires || !qrText"
            class="error-code sprite-lifelong-vip-discount sprite-lifelong-vip-discount-failure-code"
            @click="login()"
          />
          <qrcode-vue
            v-else
            :value="qrText"
            :size="110"
            level="H"
          />
        </div>

        <div class="pay-content">
          <div class="pay-text">
            <span
              class="sprite-lifelong-vip-discount sprite-lifelong-vip-discount-RichScan"
            />
            <p>
              <span>打开微信APP</span>
              <span>扫一扫进行付款</span>
            </p>
          </div>
          <p class="privilege-text">
            开通拥有<span @click="openPrivilege">20项PDF会员特权</span>
          </p>
        </div>
      </main>
    </div>
  </HModal>
</template>

<script>
import QrcodeVue from 'qrcode.vue'
import { mapGetters } from 'vuex'
import { getPayQrcode, getPayResult, getPaySetting } from '@/api/pdfPay.js'
import Cookie from 'js-cookie'
import client from '@/client/'
import { LOGIN_SERVICE, OCPC_CONVERT_TYPE, PAGE_NUM } from '@/config/dataMap'
import VueCountdown from '@chenfengyuan/vue-countdown'
import { PopupController, PopupEvent, PopupInsEnum } from '@/services/act/PopupController'
import { setVueIns } from '@/services/act/LifelongVipDiscount'
import { updateConvertData } from '@/api/login'

const payFrom = PAGE_NUM.LifelongVipDiscount

export default {
  name: 'LifelongVipDiscount',
  components: { QrcodeVue, VueCountdown },
  data () {
    const { lifelongVip } = this.$route.query
    const mainFrom = Number(lifelongVip) || 0
    return {
      countdown: 5 * 60 * 1000,
      mainFrom,
      payFrom,
      visible: false,
      qrText: null,
      isExpires: false,
      orderId: null,
      loopPayResultTimer: null,
      countdownTimer: null,
      paySetting: {},
      cumulativeTourists: 0,
      autoStart: false,
      loginNum: false,
    }
  },
  computed: {
    ...mapGetters([
      'token',
      'openId',
      'loginStatus',
      'isMember',
      'userInfo',
      'isTourist',
      'isPdfLifeMember',
      'isPdfMember',
    ]),
    preferentialPrice () {
      const { price, current_price } = this.paySetting
      return price - current_price || 0
    },
    // tid条件 tid1:2001,2002,2003
    tidCondition () {
      const { tid1 } = this.$TidObj
      const tids = [2001, 2002, 2003]
      return tids.indexOf(+tid1) >= 0
    },
    nonMember () {
      return !this.isMember && !this.isPdfLifeMember && !this.isPdfMember
    },
  },
  watch: {
    userInfo: {
      handler: function (res) {
        // 获取用户信息后再去打开
        if (res && res.open_id) {
          this.afterRefreshOpen()
        }
      },
      deep: true,
    },
  },

  mounted () {
    this.init()
  },
  methods: {
    endCountdown () {
      this.autoStart = false
      setTimeout(() => {
        this.autoStart = true
      }, 100)
    },
    transform (props) {
      Object.entries(props).forEach(([key, value]) => {
        const digits = value < 10 ? `0${value}` : value
        props[key] = `${digits}`
      })
      return props
    },
    init () {
      if (this.mainFrom) {
        this.open()
      }

      setVueIns(this) // 传入实例，方便调用refWeeklyOpen
      this.$EventBus.$on(PopupEvent.lifelongVipDiscountEvent, () => {
        this.open()
        PopupController.getIns().setPopUpCache(PopupInsEnum.lifelongVipDiscount)
      })
    },
    // 登录后刷新打开
    afterRefreshOpen () {
      if (
        sessionStorage.getItem('notLoggedIn') &&
        this.nonMember &&
        this.tidCondition
      ) {
        this.open()
        this.loginNum = true
      } else {
        this.removeStorage()
        this.loginNum = false
      }
    },
    open () {
      this.autoStart = true
      this.visible = true
      this.getPayInfo()

      if (!this.loginStatus) {
        this.report({ usertype: 1 })
      }
      if (this.loginStatus && this.nonMember) {
        this.report({ usertype: 2 })
      }
    },
    getWeeks () {
      const weeks = {}
      const currentDate = new Date()
      const timesStamp = currentDate.setHours(0, 0, 0, 0)
      const currenDay = currentDate.getDay()
      for (let i = 0; i < 7; i++) {
        const weekDay =
          timesStamp + 24 * 60 * 60 * 1000 * (i - ((currenDay + 6) % 7))
        weeks[weekDay] = false
      }
      return weeks
    },

    /**
     * 每用户单电脑每天弹出1次，每周不超过3次（物理周）
     * tid条件 tid1:2001 2002 2003
     * 退出用户关闭弹出。
     * 退出用户关闭弹出，刷新二维码登录非会员弹出。
     */
    /* eslint-disable-next-line */
    refWeeklyOpen () {
      /* eslint-disable-next-line */
      return new Promise((resolve) => {
        const touristsNum = 1 // 游客弹出次数
        const userOpenNum = 3 // 用户弹出次数
        const cacheKey = this.openId
        // tid限制
        if (!this.tidCondition) {
          resolve(true)
          return
        }
        // 游客处理
        if (!this.loginStatus && this.cumulativeTourists < touristsNum) {
          this.open()
          this.cumulativeTourists++
          resolve()
          return
        }
        // 未登录到登录弹出次数限制
        if (this.loginStatus && this.loginNum) {
          resolve(true)
          return
        }
        if (!cacheKey) {
          resolve(true)
          return
        }

        let cacheWeeks = Cookie.get(cacheKey)
        if (!cacheWeeks) {
          Cookie.set(cacheKey, this.getWeeks(), { expires: 7 })
          cacheWeeks = Cookie.get(cacheKey)
        }

        let obj = cacheWeeks && JSON.parse(cacheWeeks)
        const keys = Object.keys(obj)
        const today = new Date().setHours(0, 0, 0, 0) // 当天0点0分0秒时间戳
        const sunday = Math.max(...keys)

        // 当天时间 大于 上周日 说明是下一个周期,更新本地数据
        if (today > sunday) {
          Cookie.set(cacheKey, this.getWeeks(), { expires: 7 })
          obj = JSON.parse(Cookie.get(cacheKey))
        }

        // 当天已弹的不再弹出
        if (obj[today]) {
          resolve(true)
          return
        }

        // 累计一周弹出的次数
        const opneTime = keys.filter((e) => obj[e]).length
        if (opneTime >= userOpenNum) {
          resolve(true)
          return
        }

        this.$set(obj, today, true)
        Cookie.set(cacheKey, obj, { expires: 7 })
        this.open()
        this.cumulativeTourists++
        resolve()
      })
    },

    login () {
      this.report({ click: 1 })
      if (this.loginStatus) {
        this.getQrCodeByServer()
        return
      }
      client.common.API.userLogin({ url: LOGIN_SERVICE.url })
      sessionStorage.setItem('notLoggedIn', 1) // 未登录点击登录进行标记
    },

    async getPayInfo () {
      const data = await getPaySetting({ show: [30], is_continuous: 1 })
      const result = this.isRenderData(data)
      if (
        result &&
        result.pay_price_settings &&
        result.pay_price_settings.length != 0
      ) {
        this.paySetting = result.pay_price_settings[0] || {}
        this.getQrCodeByServer()
      }
    },
    /* eslint-disable-next-line */
    async getQrCodeByServer () {
      if (
        !this.loginStatus ||
        this.isTourist ||
        !this.openId ||
        !this.paySetting.id
      ) {
        return
      }
      this.qrCodeLoadedReport(REPORT_RELATED.qr_show.api_begin)
      const data = await getPayQrcode({
        open_id: this.openId, // 用户openid
        token: this.token,
        pay_setting_id: this.paySetting.id, // 支付配置套餐id
        pay_type: 'wx_qrcode',
        pay_from: this.payFrom,
        pay_channel: 1, // 支付渠道,1为微信
        show_from: Number(Cookie.get('show_from')) || 6303
      })
      if (data && data.resp_common && data.resp_common.ret !== 0) {
        client.techMonitor.REPORT.fetmReportQrcode({ err_code: data.resp_common.ret })
      }
      this.isExpires = false
      const result = this.isRenderData(data)

      if (result) {
        this.qrCodeLoadedReport(REPORT_RELATED.qr_show.api_success)
        // entrust_url 微信纯签约，alipay_cyclepaysign_url 支付宝周期扣款（支付并签约)
        // wxqrcode_url 微信普通支付 alipayqrcode_url 支付宝普通支付
        const url =
          result.entrust_url ||
          result.alipay_cyclepaysign_url ||
          result.wxqrcode_url ||
          result.alipayqrcode_url
        if (url) {
          this.qrText = url
          this.orderId = result.order_id || result.id
          this.isExpires = false
          this.renderQrcallback()
        }
      }
    },

    renderQrcallback () {
      this.clearLoopTimer()
      // 支付二维码生成完成，开始轮询支付结果接口
      let hour = 3600
      const time = 3
      this.loopPayResultTimer = setInterval(() => {
        hour = hour - time
        // 一小时有效期
        if (hour > 0) {
          getPayResult({
            common: {
              token: this.token,
            },
            order_id: this.orderId,
            pay_channel: 0,
            pay_type: 'wx_qrcode',
          }).then((data) => {
            const result = this.isRenderData(data)
            // 0订单支付成功,7001001为支付失败,7001002未支付,7001003支付关闭,7001005没有此订单
            if (result.data && result.data.status === 0) {
              this.clearLoopTimer()
              // 刷新用户状态，跳转到首页
              client.common.API.paySuccess({
                token: this.token,
                open_id: this.openId,
              })
              this.paySuccessCallback()
            }
          })
        } else {
          this.clearLoopTimer()
          this.isExpires = true
        }
      }, time * 1000)
    },

    isRenderData (data) {
      try {
        if (data && data.resp_common && data.resp_common.ret === 0) {
          return data
        }
        this.errerTips()
        return false
      } catch (e) {
        this.errerTips()
        return false
      }
    },

    paySuccessCallback () {
      client.common.API.getOcpcUrl().then(res => {
        updateConvertData({
          conversion_info: {
            long_code: res.logidUrl,
            convert_type: OCPC_CONVERT_TYPE.BUY,
            user_type: res.userType > 0 ? res.userType : 1,
          }
        })
      })
      this.close()
      this.$emit('paySuccess')
    },

    clearLoopTimer () {
      this.loopPayResultTimer && clearInterval(this.loopPayResultTimer)
    },

    clearCountdownTimer () {
      this.countdownTimer && clearInterval(this.countdownTimer)
    },
    qrCodeLoadedReport (qr_show) {
      const PAY_WAY = {
        WeChat: 1
      }
      const curObj = {
        payid: this.paySetting.id,
        payid_time: this.paySetting.month_length,
        payway: PAY_WAY.WeChat,
        qr_show
      }
      client.techMonitor.REPORT.fetmReportQrcode(Object.assign({}, curObj, this.qrCodeReportObj))
    },
    errerTips () {
      this.$toast('获取支付信息异常')
    },

    close () {
      this.visible = false
      this.clearLoopTimer()
      this.clearCountdownTimer()
      this.report({ click: 2 })
      this.removeStorage()
    },
    removeStorage () {
      sessionStorage.removeItem('notLoggedIn')
    },
    openPrivilege () {
      window.open('https://shimo.im/docs/ccKtPg9C6kHtYVwY')
      this.report({ click: 3 })
    },
    report ({ pageshow = 1, click = 0, usertype = 0 }) {
      client.charge.REPORT.reportChargeLifetimeVipPage({
        pageshow, // 1、关闭会员中心退弹活动 2、卸载弹出活动
        click, // 1、点击刷新二维码 2、关闭活动 3、查看详细特权
        usertype, // 1、未登录 2、已登录非会员 3、会员
      })
    },
  },
}
</script>

<style scoped lang="scss">
@import '@/assets/css/sprite-lifelong-vip-discount.scss';
::v-deep .h-modal__content {
  background: transparent;
  box-shadow: none;
}
.close-box {
  position: absolute;
  top: 49px;
  right: 54px;
  transform: scale(0.7);
  cursor: pointer;
}
.wrapper-box {
  padding: 160px 42px 0 44px;
  height: 632px - 160px;
  width: 483px - 42px - 44px;
  background: url(~@/assets/images/lifelong-vip-discount-bg.png) no-repeat;
  background-size: cover;
  header {
    margin-top: 60px;
    display: flex;
    flex-direction: column;
    align-items: center;
    color: #fff;
    h2 {
      font-size: 36px;
      font-weight: bold;
    }
    .activity-time {
      font-size: 14px;
      font-weight: 400;
      margin: 12px 0;
    }
    .time-wrapper {
      border-radius: 4px;
      display: flex;
      .times {
        display: flex;
        > .time-item {
          text-align: center;
          margin-right: 5px;
          position: relative;
          background: #c32c26;
          width: 20px;
          border-radius: 4px;
          position: relative;
          &:nth-child(2n) {
            margin-right: 10px;
          }
          &:nth-child(2n-1) {
            margin-left: 10px;
          }
          &:last-child {
            margin-right: 0;
          }
          &:first-child {
            margin-left: 0;
          }
          &:nth-last-child(2)::after,
          &:nth-child(2)::after {
            content: ':';
            display: block;
            position: absolute;
            top: -2px;
          }
          &:nth-child(2)::after {
            right: -12px;
          }
          &:nth-last-child(2)::after {
            left: -12px;
          }
        }
      }
    }

    .money-wrap {
      margin-top: 16px;
      position: relative;
      color: #e83c3b;
      .money {
        font-size: 50px;
        font-weight: bold;
        position: absolute;
        top: 35px;
        left: 40px;
        &:first-letter {
          font-size: 24px;
        }
      }
      .discount {
        position: absolute;
        left: 150px;
        top: 40px;
        font-weight: 400;
        .discount-text {
          font-size: 12px;
          > span {
            text-decoration: line-through;
          }
        }
        .discount-money {
          font-size: 28px;
        }
      }
    }
  }
  main {
    display: flex;
    justify-content: center;
    align-items: center;
    margin-top: 20px;
    .qrcode {
      margin-right: 20px;
      width: 120px;
      height: 120px;
      cursor: pointer;
    }
    .pay-content {
      font-weight: 400;
      color: #ffffff;
      .pay-text {
        display: flex;
        align-items: center;
        font-size: 14px;

        > p {
          margin-left: 7px;
          display: flex;
          flex-direction: column;
        }
      }
      .privilege-text {
        font-size: 14px;
        margin-top: 18px;
        > span {
          color: #f7d963;
          text-decoration: underline;
          cursor: pointer;
        }
      }
    }
  }
}
</style>
